module.exports = __webpack_public_path__ + "static/media/cracha.0940d4fe.jpg";